module.exports = __webpack_public_path__ + "img/Gestor4.24a31363.png";